
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Topratesbus() {



    const cardData =
    {
        keyword: 'Top Rated Bus Hire in Pune Amruta Travels',
        heading: 'Amruta Travels: Top Rated Bus Hire in Pune Amruta Travels',
        headingDescription: 'Amruta Travels stands out as one of Pune’s most trusted and top-rated bus rental services, offering a diverse fleet tailored to meet various travel needs. Whether you are planning a corporate event, wedding, family trip, or pilgrimage, Amruta Travels ensures a seamless and comfortable journey.',


        top: 'Top Places to Visit in Outstation Pune with Amruta Travels',


  "topPlaces": [
    {
      "title": "Mahabaleshwar",
      "description": "Located around 120 km from Pune, Mahabaleshwar is a picturesque hill station in the Western Ghats, known for its cool climate, evergreen forests, and stunning viewpoints such as Arthur’s Seat, Wilson Point (the highest point), and Kate's Point. The region is famous for its strawberry farms, especially during the Strawberry Festival held in spring. Other attractions include Venna Lake for boating, Mapro Garden for strawberry-based treats, and ancient temples like Panchganga and Mahabaleshwar Temple. It's a popular destination for families, honeymooners, and nature enthusiasts seeking a refreshing escape from city life."
    },
    {
      "title": "Lonavala & Khandala",
      "description": "Just 66 km from Pune, these twin hill stations in the Sahyadri range offer a perfect blend of natural beauty and adventure. Lonavala is known for its misty mountains, lush greenery, and monsoon waterfalls like Kune and Bhivpuri. Attractions include Bhushi Dam, Tiger’s Leap, Rajmachi Fort, and Karla & Bhaja Caves. Khandala is equally famous for its panoramic valley views and trekking routes. The area is ideal for a weekend drive, with scenic routes and roadside chikki stalls that add to the charm of this quick getaway."
    },
    {
      "title": "Shirdi",
      "description": "About 190 km from Pune, Shirdi is a sacred town revered by followers of Sai Baba. The Sai Baba Samadhi Mandir is the main attraction, drawing millions of devotees every year. Pilgrims can also visit Dwarkamai, Chavadi, and the Sai Heritage Village. The spiritual ambiance, combined with well-maintained infrastructure and religious events, makes Shirdi a prominent destination for those seeking peace, healing, and spiritual growth."
    },
    {
      "title": "Goa",
      "description": "Located nearly 450 km from Pune, Goa is India’s premier beach destination, known for its lively culture, golden beaches, and Portuguese heritage. From North Goa’s party hotspots like Baga, Anjuna, and Calangute to South Goa’s serene stretches like Palolem and Colva, there’s a vibe for every traveler. Apart from beaches, visitors can explore Aguada Fort, Basilica of Bom Jesus, spice plantations, vibrant flea markets, and indulge in thrilling water sports. Goa is also a haven for foodies, offering authentic seafood, Goan curries, and beachside shacks serving refreshing cocktails."
    },
    {
      "title": "Nashik",
      "description": "Around 210 km from Pune, Nashik is a city of immense cultural, historical, and spiritual significance. It is one of the four cities where the Kumbh Mela is held. Attractions include the ancient Kalaram Temple, Muktidham Temple, Pandavleni Caves, and Trimbakeshwar Temple—an important Jyotirlinga. Nashik is also the wine capital of India, home to Sula Vineyards, York Winery, and many tasting tours. The Godavari River adds to its charm, making it a harmonious blend of spirituality and leisure tourism."
    },
    {
      "title": "Alibaug",
      "description": "Situated about 140 km from Pune, Alibaug is a tranquil coastal town offering a perfect mix of beaches, history, and nature. Popular beaches include Nagaon, Alibaug Beach, and Kashid Beach, all great for swimming, sunbathing, and water sports. The iconic Kolaba Fort, accessible during low tide, adds historical value to the destination. You can also explore Korlai Fort, Kanakeshwar Temple, and local seafood cuisine. Ideal for weekend trips, Alibaug also offers ferry services from Mumbai for added convenience."
    },
    {
      "title": "Kolhapur",
      "description": "Roughly 235 km from Pune, Kolhapur is a vibrant city known for its divine Mahalaxmi Temple, which draws pilgrims throughout the year. The city is equally famous for its spicy cuisine, Kolhapuri chappals, and traditional arts. Attractions include Rankala Lake for evening strolls, Panhala Fort offering panoramic views, and the New Palace Museum showcasing royal heritage. With its rich cultural identity and warm hospitality, Kolhapur is ideal for heritage and culinary tourism."
    },
    {
      "title": "Lavasa",
      "description": "Just 60 km from Pune, Lavasa is an Italian-inspired planned city nestled in the Sahyadri hills. It features beautiful waterfronts, European-style architecture, and a peaceful atmosphere perfect for a quick weekend escape. Activities include kayaking, zip-lining, and lakeside cycling. With cozy resorts, conference centers, and nature trails, Lavasa attracts both families and corporate travelers. The weather remains pleasant most of the year, enhancing its appeal as a rejuvenating destination close to Pune."
    },
    {
      "title": "Satara & Kaas Plateau",
      "description": "About 120 km from Pune, Satara serves as the base for exploring the Kaas Plateau—popularly known as the 'Valley of Flowers' of Maharashtra. The plateau, a UNESCO World Natural Heritage site, bursts into a riot of colors with over 850 species of wildflowers during the monsoon season. Satara is also known for Ajinkyatara Fort, Thoseghar Waterfalls, and Sajjangad Fort. The natural beauty and biodiversity make this region a paradise for trekkers, botanists, and photographers."
    },
    {
      "title": "Aurangabad",
      "description": "Situated 235 km from Pune, Aurangabad is a historical treasure trove, offering insights into ancient art, architecture, and culture. The city is home to the world-famous Ajanta and Ellora Caves, adorned with exquisite carvings and paintings dating back to 2nd century BCE. Other attractions include Bibi Ka Maqbara (a replica of the Taj Mahal), Daulatabad Fort, and Aurangabad Caves. The city is also a gateway to Grishneshwar Jyotirlinga and Paithani saree shopping, making it a must-visit for heritage lovers."
    }
  ],

  "services": [
    {
      "name": "Best Bus Hire Pune – Amruta Travels",
      "description": "Amruta Travels is one of the best bus hire services in Pune, offering reliable, comfortable, and affordable bus rental options for any occasion. Whether it's for a corporate event, a family trip, or a wedding, we provide a seamless experience with a fleet of well-maintained buses."
    },
    {
      "name": "Top Bus Service Provider Pune",
      "description": "As a top bus service provider in Pune, Amruta Travels prides itself on offering top-notch bus rental services. With a focus on customer satisfaction and safety, we ensure that your travels are comfortable, punctual, and worry-free."
    },
    {
      "name": "Amruta Travels Luxury Bus Hire",
      "description": "For those seeking a premium travel experience, Amruta Travels offers luxury bus hire services. Our fleet of luxury buses is equipped with modern amenities to ensure your journey is comfortable, whether for corporate trips, weddings, or long-distance travel."
    },
    {
      "name": "Pune AC Bus Rentals",
      "description": "Amruta Travels offers AC bus rentals in Pune, ensuring a cool and comfortable travel experience during the summer months. Our fleet of air-conditioned buses provides the perfect solution for group trips, school outings, and corporate events."
    },
    {
      "name": "Amruta Travels Event Bus Hire",
      "description": "When it comes to organizing events, Amruta Travels provides customized event bus hire services. Whether it's for a wedding, a corporate event, or a social gathering, we ensure your guests travel in comfort and style."
    },
    {
      "name": "Multi-Seater Bus Services Pune",
      "description": "Looking for a bus that can accommodate a larger group? Amruta Travels offers multi-seater bus services in Pune, with buses ranging from 25 to 50 seats. We cater to groups of all sizes, ensuring your trip is both comfortable and affordable."
    },
    {
      "name": "Pune Tour Bus Amruta Travels",
      "description": "Explore Pune and nearby destinations with our Pune Tour Bus services. Whether it's sightseeing, a religious tour, or a day trip, Amruta Travels provides comfortable buses equipped with modern amenities for a smooth journey."
    },
    {
      "name": "Volvo Bus Rental Pune",
      "description": "For those seeking premium travel options, Amruta Travels offers **Volvo bus rentals in Pune**. Our Volvo buses are ideal for long-distance trips, corporate events, and large group travel, providing maximum comfort and luxury."
    },
    {
      "name": "Corporate Bus Services Pune",
      "description": "Amruta Travels specializes in corporate bus services in Pune, providing reliable and efficient transportation for employee commutes, business meetings, and corporate outings. We ensure timely and comfortable travel for your team."
    },
    {
      "name": "Wedding Bus Provider Pune",
      "description": "Planning a wedding? Amruta Travels offers wedding bus services in Pune to ensure your guests travel comfortably to the wedding venue. Our buses can accommodate large groups, making transportation stress-free for your big day."
    },
    {
      "name": "45 Seater Bus Amruta Travels",
      "description": "Amruta Travels provides **45-seater buses** for large group travel. Whether it's for a corporate event, school picnic, or family trip, our 45-seater buses are spacious, comfortable, and fully equipped for a relaxing journey."
    },
    {
      "name": "Outstation Bus Amruta Travels",
      "description": "For long-distance travel, **Amruta Travels** offers outstation bus hire services. Whether it's a pilgrimage, family vacation, or corporate trip, we provide reliable and comfortable transportation to destinations across India."
    },
    {
      "name": "Pune to Shirdi/Nashik/Aurangabad Bus",
      "description": "Amruta Travels offers dedicated bus services from Pune to popular destinations like **Shirdi**, **Nashik**, and **Aurangabad**. Our buses are well-equipped to provide a comfortable and safe journey for groups visiting these religious and tourist sites."
    },
    {
      "name": "AC Bharat Benz Amruta Bus Hire",
      "description": "For an elevated travel experience, Amruta Travels offers **AC Bharat Benz bus hire**. Known for its luxury and comfort, the Bharat Benz buses are perfect for both short and long-distance trips, offering the perfect blend of style and comfort."
    },
    {
      "name": "Group Travel Bus Rental Amruta",
      "description": "Amruta Travels provides group travel bus rental services, ensuring your entire group travels together in comfort. Whether it’s a corporate outing, a family tour, or a school trip, our buses are ideal for any group travel requirement."
    }
  ],
  "tableData": [
    ["Best Bus Hire Pune – Amruta Travels", "Top Bus Service Provider Pune"],
    ["Amruta Travels Luxury Bus Hire", "Pune AC Bus Rentals"],
    ["Amruta Travels Event Bus Hire", "Multi-Seater Bus Services Pune"],
    ["Pune Tour Bus Amruta Travels", "Volvo Bus Rental Pune"],
    ["Corporate Bus Services Pune", "Wedding Bus Provider Pune"],
    ["45 Seater Bus Amruta Travels", "Outstation Bus Amruta Travels"],
    ["Pune to Shirdi/Nashik/Aurangabad Bus", "AC Bharat Benz Amruta Bus Hire"],
    ["Group Travel Bus Rental Amruta"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Top Rated Bus Hire in Pune - Amruta Travels",
    "WhyChoosedescription": "Amruta Travels is the top-rated bus hire service in Pune, providing reliable, safe, and comfortable transportation for a wide range of travel needs. Whether you're planning a corporate trip, school excursion, family outing, or religious pilgrimage, our fleet of well-maintained buses ensures a smooth and hassle-free experience."
  },
  {
    "WhyChooseheading": "Comfort and Convenience for Every Journey",
    "WhyChoosedescription": "Our buses are equipped with comfortable seating, air-conditioning, ample legroom, and other essential amenities, ensuring a comfortable travel experience for all passengers. Whether it's a short trip or a long journey, our top-rated buses offer convenience and relaxation for everyone."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "At Amruta Travels, we employ only experienced, licensed, and professional drivers who are familiar with Pune’s local routes and outstation destinations. They prioritize safety, punctuality, and excellent service, making sure your journey is smooth and enjoyable."
  },
  {
    "WhyChooseheading": "A Fleet of Well-Maintained Buses for Safe Travel",
    "WhyChoosedescription": "We pride ourselves on our well-maintained fleet of buses, which are regularly serviced, cleaned, and inspected to ensure the highest standards of safety and performance. Whether you’re traveling for business, leisure, or a special event, our buses are road-ready for every trip."
  },
  {
    "WhyChooseheading": "Affordable, Transparent, and No-Hidden-Fee Pricing",
    "WhyChoosedescription": "Our pricing is competitive, transparent, and inclusive of all charges such as fuel, tolls, driver allowances, and taxes. We make it easy to plan your travel budget, with no hidden costs or surprise fees, ensuring a stress-free booking experience."
  },
  {
    "WhyChooseheading": "Customized Solutions for Any Group Size and Occasion",
    "WhyChoosedescription": "Amruta Travels offers flexible bus hire solutions tailored to your specific needs. Whether you're booking for a small group or a large team, for a short local trip or a long-distance journey, we have the right bus and the right services to match your requirements."
  },
  {
    "WhyChooseheading": "Highly Rated for Exceptional Customer Service",
    "WhyChoosedescription": "Our customers consistently rate us highly for our prompt, reliable, and friendly customer service. Whether you need help with booking, itinerary changes, or special requests, our 24/7 customer support team is always ready to assist you, ensuring a smooth and worry-free travel experience."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking and Support at Your Convenience",
    "WhyChoosedescription": "Booking a bus with Amruta Travels is simple and convenient. You can book online, over the phone, or in person. We offer flexibility with booking changes and are always available to support you through our 24/7 customer care team, ensuring a seamless experience from start to finish."
  }
]
























    }

const faqData = [
  {
    question: 'Why is Amruta Travels considered a top-rated bus hire service in Pune?',
    answer: 'Amruta Travels is recognized for its reliable, safe, and comfortable bus hire services in Pune. With a fleet of well-maintained buses, experienced drivers, and exceptional customer service, we ensure every journey meets the highest standards of quality and satisfaction.',
  },
  {
    question: 'What types of buses are available for hire at Amruta Travels?',
    answer: 'At Amruta Travels, we offer a variety of buses for hire including 25-seater, 32-seater, 45-seater, and luxury buses, all of which come with essential amenities like air conditioning, comfortable seating, and more. We provide buses suitable for corporate events, family outings, pilgrimages, and other group travels.',
  },
  {
    question: 'Are the buses well-maintained and sanitized?',
    answer: 'Yes, all buses at Amruta Travels are thoroughly maintained, regularly inspected, and cleaned before each trip. We ensure all our buses are sanitized, well-equipped, and in top condition for a safe and comfortable travel experience.',
  },
  {
    question: 'Are drivers included in the bus hire?',
    answer: 'Yes, every bus rental from Amruta Travels includes an experienced, licensed driver. Our drivers are professional, knowledgeable of the local routes, and committed to ensuring your safety and comfort throughout the journey.',
  },
  {
    question: 'How much does it cost to hire a bus from Amruta Travels in Pune?',
    answer: 'The cost of hiring a bus from Amruta Travels varies based on the bus type, trip distance, duration, and specific requirements. Typically, prices range from ₹28–₹45 per km. For a precise quote, we recommend contacting us with your specific itinerary.',
  },
  {
    question: 'Is Amruta Travels known for providing luxury buses?',
    answer: 'Yes, Amruta Travels offers a fleet of luxury buses that provide premium services, including comfortable seating, air conditioning, entertainment systems, and more. These buses are perfect for corporate events, weddings, and group tours that require extra comfort and style.',
  },
  {
    question: 'How do I book a bus with Amruta Travels?',
    answer: 'Booking a bus with Amruta Travels is simple. You can book online through our website or by contacting our customer support team. We provide fast and efficient booking assistance and offer flexible packages based on your travel needs.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Shankar Patil',
    role: 'Business Owner, Pune',
    text: 'I hired a 45-seater bus from Amruta Travels for a corporate event. The bus was luxurious, well-maintained, and comfortable. The driver was experienced and professional. It was a top-notch experience. I highly recommend Amruta Travels for any group travel.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Priya Gupta',
    role: 'Event Planner, Pune',
    text: 'We used Amruta Travels for a group tour, and the service was exceptional. The bus was clean, the amenities were excellent, and the trip went smoothly. I’ve used other services in the past, but Amruta Travels stands out for their reliability and professionalism.',
    rating: 5,
  },
  {
    id: 3,
    name: 'Mr. Aakash Deshmukh',
    role: 'Tour Operator, Pune',
    text: 'Amruta Travels provided us with a luxurious 32-seater bus for a family trip. The journey was comfortable and pleasant, and the service was great from start to finish. They are truly a top-rated bus hire service in Pune.',
    rating: 5,
  },
];































































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Top Rated Bus Hire in Pune - Amruta Travels",
  "image": "https://bushireinpune.com/assets/images/amruta-travels-top-rated-bus-hire-pune.jpg",
  "description": "Amruta Travels offers top-rated bus hire services in Pune, providing luxury buses for corporate events, weddings, tours, and outstation travel. Our fleet includes 45-seater, Volvo, and Bharat Benz buses for group travel, family tours, and more. Hire an AC bus for a comfortable and safe journey from Pune to Shirdi, Nashik, Aurangabad, and beyond.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2200"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "9500",
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/top-rated-bus-hire-amruta-travels-pune"
  }
};





    return (
        <div>


<Helmet>
  <title>Call: +91 7353109555 | Top Rated Bus Hire in Pune | Luxury Bus Rentals & Group Travel | Amruta Travels</title>
  <meta 
    name="description" 
    content="Hire top-rated buses from Amruta Travels in Pune. We offer luxury bus rentals for corporate events, weddings, tours, and outstation travel. Choose from 45-seater, Volvo, and Bharat Benz buses for group trips and more." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/93.png' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Topratesbus;